import React from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['Buscando entre papeles sueltos qué trabajaste en la sesión anterior', 'Preguntándole al paciente cómo se sentía porque no tenés registro de la vez pasada', 'Sin evidencia de la evolución de tus tratamientos para mostrarle al paciente su progreso', 'Siempre las mismas fichas improvisadas porque no tenés un sistema clínico serio', 'Sin documentación profesional que respalde tu trabajo y te proteja ante cualquier situación', 'El gabinete sin insumos en plena jornada porque nunca controlás el stock', 'Pacientes que no vuelven porque no perciben el valor profesional de tu trabajo', 'Cada semana empezás el mismo ciclo de caos, una y otra vez'];
  return <Section className="max-w-4xl" data-id="element-299">
      <div className="text-center mb-12" data-id="element-300">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-serif font-bold mb-6 leading-tight" data-id="element-301">
          El desorden en el gabinete tiene un costo que quizás no estás viendo
        </h2>
        <p className="text-brand-text/80 mb-4 text-sm md:text-base max-w-2xl mx-auto" data-id="element-302">
          Un paciente que no siente progreso, no vuelve. La diferencia entre
          fidelizar o perder pacientes no está en tu técnica. Está en cómo
          documentás y hacés seguimiento.
        </p>

        <p className="text-lg md:text-xl font-medium text-brand-rose mt-6" data-id="element-303">
          No es falta de vocación. Es falta de un sistema.
        </p>
      </div>

      <div className="glass-panel p-6 md:p-10 rounded-3xl mb-12 bg-white/60 border-brand-pink/30" data-id="element-304">
        <h3 className="font-medium mb-6 flex items-center text-brand-text/90 text-base md:text-lg" data-id="element-305">
          <X className="w-6 h-6 text-red-500 mr-2 shrink-0" data-id="element-306" /> Lo que pasa sin
          REFLEXO-PRO:
        </h3>
        <ul className="space-y-4" data-id="element-307">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-308">
              <X className="w-5 h-5 text-red-400 mr-3 mt-0.5 shrink-0" data-id="element-309" />
              <span className="text-brand-text/80 text-sm md:text-base" data-id="element-310">
                {point}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-311">
        <h3 className="text-xl md:text-3xl font-serif font-bold rose-gradient-text" data-id="element-312">
          ¿Y si esta fuera la última semana que trabajás así?
        </h3>
      </div>
    </Section>;
};